import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const MaxSpeed = ({ maxSpeed }: SpecProps<"max_speed">) => {
  const { i18n } = useLingui();

  if (maxSpeed == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.maxSpeed",
    message: "Max speed",
    comment: "Field for 'max speed' in ad specification for construction",
  });
  const value = i18n.t({
    id: "itemPageLayout.keyInfo.maxSpeed.kilometerPerHour.value",
    message: "{maxSpeed} km/h",
    comment: "Field for 'max speed' in ad specification construction",
    values: { maxSpeed: maxSpeed },
  });
  return <FieldValuePair field={field} value={value} />;
};
